// eslint-disable-next-line import/no-unresolved
import { CommonProps, CopyIcon, Text, TextButton, Toast } from '@modusign/design-system';
import * as CSS from 'csstype';
import { useCallback } from 'react';
import { useCopyToClipboard } from 'react-use';
import { ResponsiveValue } from 'styled-system';

interface ClipboardCopyableTextProps {
  fontSize?: ResponsiveValue<'xs' | 'sm' | 'md' | 'lg' | CSS.Property.FontSize>;
  fontWeight?: ResponsiveValue<'regular' | 'medium' | CSS.Property.FontWeight>;
  children: string;
  label?: string;
  color?: CommonProps['color'];
}

const defaultProps = {
  color: 'textNeutralLight',
};

function ClipboardCopyableText({
  children,
  fontSize,
  fontWeight,
  label,
  color,
}: ClipboardCopyableTextProps) {
  const [, copyToClipboard] = useCopyToClipboard();

  const handleCopyToClipboard = useCallback(() => {
    copyToClipboard(children);

    Toast.success({
      description: label ? `${label}를 복사했습니다.` : '텍스트를 복사했습니다.',
      bodyStyle: { width: '310px' },
    });
  }, [copyToClipboard, children, label]);

  return (
    <TextButton
      color={color}
      display="inline-block"
      sx={{
        '& .ClipboardCopyableText__copyIcon': {
          display: 'none',
        },
        '&:hover .ClipboardCopyableText__copyIcon': {
          display: 'unset',
        },
      }}
      textAlign="left"
      textDecoration="plain"
      onClick={handleCopyToClipboard}
    >
      <Text color={color} fontSize={fontSize} fontWeight={fontWeight} mr={1}>
        {children}
      </Text>
      <CopyIcon className="ClipboardCopyableText__copyIcon" />
    </TextButton>
  );
}

ClipboardCopyableText.defaultProps = defaultProps;

export default ClipboardCopyableText;
